export default __webpack_public_path__ + "static/media/profile3.13ddb6c7.svg";